export default {
    shareLinkDialogDefaultTimeUnit: 'week',
    shareLinkDialogDefaultTimeQuantity: 2,
}